// TDic、Tproの正誤判定処理

import common from '@/mixin/common'

const BAD_STYLE = '<span style="background-color:#0000ff; color:#ffffff;">{text}</span>';
const BR_STYLE = '<br>';
// 解答欄の1行に表示する最大文字数
const LINE_LENGTH = 40;

export default {
  data () {
    return {
      contractionMap: null,
      abbreviationMap: null,
      numberMap: null,
      ignorePeriodWordList: null
    }
  },
  created() {
    // 短縮形のマップ
    this.contractionMap = new Map([
      ["i'm", "i am"],
      ["i'd", "i would"], // "i had"
      ["i'll", "i will"],
      ["i've", "i have"],
      ["you're", "you are"],
      ["you'll", "you will"],
      ["you'd", "you would"], // "you had"
      ["you've", "you have"],
      ["he's", "he is"], // "he has"
      ["he'll", "he will"],
      ["he'd", "he would"], // "he had"
      ["she's", "she is"], // "she has"
      ["she'll", "she will"],
      ["she'd", "she would"], // "she had"
      ["it's", "it is"], // "it has"
      ["it'll", "it will"],
      ["it'd", "it would"], // it had
      ["we're", "we are"],
      ["we'll", "we will"],
      ["we'd", "we would"], // "we had"
      ["we've", "we have"],
      ["they're", "they are"],
      ["they'll", "they will"],
      ["they'd", "they would"], // "they had"
      ["they've", "they have"],
      ["that's", "that is"], // "that has"
      ["that'd", "that had"], // "that would"
      ["that'll", "that will"],
      ["who's", "who is"], // "who has"
      ["who'd", "who had"], // "who would", "who did"
      ["who'll", "who will"],
      ["who've", "who have"],
      ["what's", "what is"], // "what has"
      ["what'd", "what had"], // "what would", "what did"
      ["what'll", "what will"],
      ["what're", "what are"],
      ["what've", "what have"],
      ["where's", "where is"], // "where has"
      ["where'd", "where had"], // "where would", "where did"
      ["where'll", "where will"],
      ["where've", "where have"],
      ["when's", "when is"], // "when has"
      ["when'd", "when had"], // "when would", "when did"
      ["when'll", "when will"],
      ["when've", "when have"],
      ["why's", "why is"], // "why has"
      ["why'd", "why had"], // "why would", "why did"
      ["why'll", "why will"],
      ["why've", "why have"],
      ["how's", "how is"], // "how has"
      ["how'd", "how had"], // "how would", "how did"
      ["how'll", "how will"],
      ["how've", "how have"],
      ["there's", "there is"], // "there has"
      ["there'd", "there had"], // "there would"
      ["there'll", "there will"],
      ["can't", "cannot"],
      ["couldn't", "could not"],
      ["don't", "do not"],
      ["doesn't", "does not"],
      ["didn't", "did not"],
      ["isn't", "is not"],
      ["wasn't", "was not"],
      ["aren't", "are not"],
      ["weren't", "were not"],
      ["haven't", "have not"],
      ["hasn't", "has not"],
      ["hadn't", "had not"],
      ["mightn't", "might not"],
      ["mustn't", "must not"],
      ["needn't", "need not"],
      ["shouldn't", "should not"],
      ["won't", "will not"],
      ["wouldn't", "would not"],
      // 別の表現に置き換え
      ["alright", "all right"],
      ["expressway", "express way"],
    ]);
    // 省略形のマップ
    this.abbreviationMap = new Map([
      ["mt.", "mount"],
      ["ok.", "okay."],
    ]);
    // 数字のマップ
    this.numberMap = new Map([
      ["1st", "first"],
      ["2nd", "second"],
      ["3rd", "third"],
      ["1", "one"],
      ["2", "two"],
      ["3", "three"],
      ["4", "four"],
      ["5", "five"],
      ["6", "six"],
      ["7", "seven"],
      ["8", "eight"],
      ["9", "nine"],
      ["10", "ten"]
    ]);
    // ピリオドの次の単語でも先頭が大文字かどうかの判定をさせたくない単語。
    // 短縮形の変換や省略形の置き換えなどが終わった後の形で定義するために、実際に使っている変換ロジックを通したリストを作る。
    const orgIgnorePeriodWordList = [
      'a.m.',
      'p.m.'
    ];
    this.ignorePeriodWordList = [];
    for(let i =0; i < orgIgnorePeriodWordList.length; i++){
      var tmp = this.replaceAbbreviation(orgIgnorePeriodWordList[i]);
      var tempList = [tmp];
      this.ignorePeriodWordList.push(this.conversion(tempList)[0].get('word'));
    };
  },
  methods: {
    /**
    * 正誤判定
    * 正解の場合は空文字を、不正解の場合はstyleを付与した解答文を返却
    */
    checkProcess: function(questionText, answerText) {
      this.log('start checkProces');
      this.log('question text: ' + questionText);
      this.log('answer text: ' + answerText);

      // 空文字の場合
      if(answerText.length == 0) {
        var checkResult = this.createResult(false, BAD_STYLE.replace('{text}', '&nbsp;'));
        return checkResult;
      }

      // 省略形を置き換える
      var question = this.replaceAbbreviation(questionText);
      var answer = this.replaceAbbreviation(answerText);

      // 単語に分解
      var split_q = this.splitWord(question);
      var split_a = this.splitWord(answer);

      // 改行を追加
      var questionList = this.addLineBreak(split_q);
      var answerList = this.addLineBreak(split_a);

      // 短縮形、数字を変換
      var questionWordList = this.conversion(questionList);
      var answerWordList = this.conversion(answerList);

      // 動作確認用ログ
      var logs_q = [];
      var logs_a = [];
      questionWordList.forEach((item) => {
        logs_q.push(item.get('word'));
      });
      this.log('question word list: ' + logs_q.join(' '));
      answerWordList.forEach((item) => {
        logs_a.push(item.get('word'));
      });
      this.log('answer word list: ' + logs_a.join(' '));

      // 単語ごとに比較
      var res = true;
      var uppercase = false;
      for(var i = 0; i < questionWordList.length; i++) {
        // 単語数が足りない
        if(answerWordList[i] == undefined) {
          answerList[answerList.length] = BAD_STYLE.replace('{text}', '&nbsp;');

          var checkResult = this.createResult(false, answerList.join(' '));
          return checkResult;
        }

        // 一致するか確認
        var answerOrgindex = answerWordList[i].get('orgIndex');
        if(questionWordList[i].get('word') != answerWordList[i].get('word')) {
          answerList[answerOrgindex] = BAD_STYLE.replace('{text}', answerList[answerOrgindex]);

          var checkResult = this.createResult(false, answerList.join(' '));
          return checkResult;
        }

        // 前の単語の末尾が.!?の場合、先頭が大文字または."か確認
        if(uppercase == true) {
          const regex = /^[A-Z."]/;
          var found = answerList[answerOrgindex].match(regex);
          if(!found) {
            answerList[answerOrgindex] = BAD_STYLE.replace('{text}', answerList[answerOrgindex]);

            var checkResult = this.createResult(false, answerList.join(' '));
            return checkResult;
          }
        }

        // 末尾が.!?か確認
        //.!?の場合は次の単語が先頭大文字でなければならないのでフラグを立てる。
        uppercase = this.checkEndOfSentence(answerWordList[i].get('word'), answerList[answerOrgindex]);
      }

      // 前方までは正解だが、後方に不要な文字列が含まれている場合
      // ex. question:this is a pen. answer:this is a pen pen.
      if(questionWordList.length < answerWordList.length && res == true) {
        var len = questionWordList.length;
        var index = answerWordList[len].get('orgIndex');
        answerList[index] = BAD_STYLE.replace('{text}', answerList[index]);

        var checkResult = this.createResult(false, answerList.join(' '));
        return checkResult;
      }

      // 末尾がカンマか確認
      var end = answer.substring(answer.length - 1);
      if(end === ',') {
        var len = answerWordList.length - 1;
        var index = answerWordList[len].get('orgIndex');
        answerList[index] = BAD_STYLE.replace('{text}', answerList[index]);
        res = false;
      }

      var checkResult = this.createResult(res, answerList.join(' '));
      return checkResult;
    },
    /**
     * 正誤判定の結果を作成
     */
    createResult: function(res, answer) {
      var result = new Map();
      result.set('res', res);
      result.set('answer', answer);
      return result;
    },
    /**
     * 単語に分解
     */
    splitWord: function(text) {
      const regex = /[!?,.]/gi;
      var str = text.replace(regex, '$& ');

      var split = str.split(' ');
      return this.deleteEmpty(split);
    },
    /**
     * 空文字を取り除く
     */
    deleteEmpty: function(wordList) {
      var res = [];

      for(var i = 0; i < wordList.length; i++) {
       if(wordList[i].length != 0) {
         res.push(wordList[i]);
       }
      }

      return res;
    },
    /**
     * 改行を追加
     */
    addLineBreak: function(wordList) {
      var res = [];

      var len = 0;
      for(var i = 0; i < wordList.length; i++) {
        len = len + wordList[i].length + 1;

        if(len >= LINE_LENGTH) {
          res.push(BR_STYLE);
          len = wordList[i].length + 1;
        }
        res.push(wordList[i]);
      }

      // 最後が改行の場合、削除
      if(res[res.length] == BR_STYLE) {
        res = res.pop();
      }

      return res;
    },
    /**
     * 省略形を置き換える
     */
    replaceAbbreviation: function(text) {
      var res = text.replace(/p\.m/gi, 'pm');
      res = res.replace(/a\.m/gi, 'am');
      res = res.replace(/o\.k/gi, 'ok');

      return res;
    },
    /**
     * 感嘆符、カンマを終止符に置き換える
     * 全て小文字に変換する
     */
    replacePeriod: function(text) {
      const regex = /[!,]/gi;
      var str = text.replace(regex, '.');
      var res = str.toLowerCase();

      return res;
    },
    /**
     * 短縮形、数字を変換
     * Mapオブジェクトの配列を返却する
     * Mapオブジェクトは、以下の通り
     *  key:word, value:変換後の単語
     *  key:orgIndex, value:変換前のwordListのインデックス
     */
    conversion: function(wordList) {
      var res = [];

      var orgIndex = 0;
      for(var i = 0; i < wordList.length; i++) {
        if(wordList[i] == BR_STYLE) {
          continue;
        }

        var word = this.replacePeriod(wordList[i]);

        // アポストロフィが含まれている場合、シングルクォートでも許容する
        word = word.replace(/[’]/gi, '\'');

        // 短縮形
        // 記号で分割
        const regex = /[!?,.]/gi;
        var str = word.replace(regex, ' $&');
        var split = str.split(' ');

        // 記号だけを取り出す
        var symbol = '';
        if(split.length > 1) {
          var reg = /[!?,.]+/gi;
          symbol = word.match(reg);
        }

        var contraction = this.contractionMap.get(split[0]);
        if(contraction != undefined) {
          var contractionList = this.splitWord(contraction);
          for(var j = 0; j < contractionList.length; j++) {
            var item = contractionList[j].trim();
            if(j == (contractionList.length - 1)) {
              item = item.concat(symbol);
            }

            var dataMap = new Map();
            dataMap.set('word', item);
            dataMap.set('orgIndex', orgIndex);
            res.push(dataMap);
          }
          orgIndex++;
          continue;
        }

        // 省略形
        var abbreviation = this.convertAbbreviation(word);
        if(word != abbreviation) {
          var dataMap = new Map();
          dataMap.set('word', abbreviation);
          dataMap.set('orgIndex', orgIndex);
          res.push(dataMap);
          orgIndex++;
          continue;
        }

        // 単語を接続するハイフン
        var replaceStr = word.replace(/[-]/gi, ' ');
        var hyphenList = this.splitWord(replaceStr);
        hyphenList.forEach((item) => {
          // 数字を変換
          var number = this.convertNumber(item);
          var dataMap = new Map();
          dataMap.set('word', number);
          dataMap.set('orgIndex', i);
          res.push(dataMap);
        });

        orgIndex++;
      }

      return res;
    },
    /**
     * 省略系を変換
     */
    convertAbbreviation: function(word) {
      var res = '';

      // 変換
      var abbreviation = this.abbreviationMap.get(word);
      if(abbreviation != undefined) {
        res = abbreviation.trim();
      } else {
         res = word.trim();
      }

      return res;
    },
    /**
     * 数字を変換
     */
    convertNumber: function(word) {
      var res = '';

      // "2."の場合があり得るので、"2"と記号に分割
      const regex = /[!?,.]/gi;
      var str = word.replace(regex, ' $&');
      var split = str.split(' ');

      split.forEach((item) => {
        // 変換
        var number = this.numberMap.get(item);
        if(number != undefined) {
          res = res + number;
        } else {
          res = res + item;
        }
      });

      return res;
    },
    /**
     * 末尾が.!?か確認。
     * @param {string} text 補正後のワード
     * @param {string} originalText オリジナルテキスト
     * @return {boolean} 末尾が.!?の判定ならtrue
     */
    checkEndOfSentence: function(text, originalText) {
      //ignorePeriodWordListに含まれる場合は末尾が.!?ではないと判定。'p.m.(変換後なのでpm.)'など。
      if(this.ignorePeriodWordList.includes(text)){
        return false;
      }
      // 末尾が.!?か確認。
      const regex = /[!?.]$/;
      var found = text.match(regex) != null;
      // replacePeriod()で変換しているので、変換前の単語も確認する。変換前がカンマの場合はピリオドじゃない判定にする
      const orgRegex = /[,]$/;
      var orgFound = originalText.match(orgRegex) == null ;
      return (orgFound && found);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/tdic.js